module.exports = __webpack_public_path__ + "img/st-vincent-and-the-grenadines.60113cb8.svg";